import React from 'react';
import Section from './section';
import { humanizeKey } from '../../profile-explanation-utils';

interface IResolutionConfigSectionProps {
    resolutionConfig: {
        resolution_order?: string[];
        skipped_categories?: string[];
        merge_strategy?: string;
    };
}

const ResolutionConfigSection: React.FC<IResolutionConfigSectionProps> = ({ resolutionConfig }) => {
    return (
        <Section title="Resolution config">
            <div className="profile-explanation-resolution">
                {resolutionConfig.resolution_order && (
                    <div className="profile-explanation-resolution-flow">
                        {resolutionConfig.resolution_order.map((cat, i) => (
                            <React.Fragment key={cat}>
                                <span className="profile-explanation-resolution-step">
                                    {humanizeKey(cat)}
                                </span>
                                {i < (resolutionConfig.resolution_order?.length ?? 1) - 1 && (
                                    <span className="profile-explanation-resolution-arrow">→</span>
                                )}
                            </React.Fragment>
                        ))}
                    </div>
                )}
                {resolutionConfig.merge_strategy && (
                    <div className="profile-explanation-row">
                        <span className="profile-explanation-label">Merge strategy</span>
                        <span>{humanizeKey(resolutionConfig.merge_strategy)}</span>
                    </div>
                )}
            </div>
        </Section>
    );
};

export default ResolutionConfigSection;
